module.exports = __webpack_public_path__ + "static/media/md-beer.ffbef646.svg";